import { computed } from "nanostores";

import type {
  ListIntegrationsData,
  ListIntegrationsResponse,
} from "../api/types.gen.ts";

import { getIntegration, listIntegrations } from "../api";
import { createPaginationStore } from "../stores/pagination.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $integrationsPagination = createPaginationStore();

const $paginationParamsString = computed(
  $integrationsPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $integrationsList = createApiStore<
  ListIntegrationsResponse,
  ListIntegrationsData
>(listIntegrations, {
  mapToOptions: ([paginationParamsString, route]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    const isGraphRoute = route === "graph" || route === "alert-sources";

    const pageSize = isGraphRoute
      ? Number.MAX_SAFE_INTEGER
      : paginationParams.pageSize;

    return {
      query: {
        currentPage: paginationParams.currentPage,
        pageSize: pageSize,
      },
    };
  },
  params: [
    $paginationParamsString,
    computed($router, (route) => String(route?.route)),
  ],
  storeKey: "integrationsList",
});

export const $integrationContent = createApiStore(getIntegration, {
  mapToOptions: ([integrationId]) => ({
    path: { id: integrationId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "integrationId" in router.params
        ? router.params.integrationId
        : null;
    }),
  ],
  storeKey: "integrationContent",
});
